import React from 'react';
import '../styles/PhotoAlbum.css'; // Create this CSS file for custom styling

const PhotoAlbum = () => {
    return (
        <div className="photo-album">
            <h1 className="album-title">Underhill Family Reunion Photo Album</h1>

            <div className="album-year">
                <h2>2025 - Upcoming Reunion</h2>
                <div className="album-placeholder">
                    <p>No photos available yet. Check back after the reunion!</p>
                </div>
            </div>

            <div className="album-year">
                <h2>2026 - Coming Soon!</h2>
                <div className="album-placeholder">
                    <p>No photos available yet. Check back after the reunion!</p>
                </div>
            </div>

            <div className="album-year">
                <h2>2027 - Coming Soon!</h2>
                <div className="album-placeholder">
                    <p>No photos available yet. Check back after the reunion!</p>
                </div>
            </div>

            <div className="album-year">
                <h2>2028 - Coming Soon!</h2>
                <div className="album-placeholder">
                    <p>No photos available yet. Check back after the reunion!</p>
                </div>
            </div>

            {/* Add more years as needed */}

        </div>
    );
};

export default PhotoAlbum;